{
  "name": "borgo-loan-fe",
  "version": "2.0.0-2a3bd5ef.0",
  "scripts": {
    "watch": "ng test",
    "build": "./scripts/version.sh && ng build",
    "install": "cp ./package.json ./src/assets",
    "lint": "ng lint",
    "ng": "ng",
    "start": "cp ./package.json ./src/assets && ng serve --ssl --host localhost.sparbanken.me",
    "style-lint": "stylelint  src/**/*.scss --fix",
    "test": "ng test --watch=false --code-coverage"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^21.0.5",
    "@angular/cdk": "^21.0.3",
    "@angular/common": "^21.0.5",
    "@angular/compiler": "^21.0.5",
    "@angular/core": "^21.0.5",
    "@angular/forms": "^21.0.5",
    "@angular/material": "^21.0.3",
    "@angular/platform-browser": "^21.0.5",
    "@angular/platform-browser-dynamic": "^21.0.5",
    "@angular/router": "^21.0.5",
    "rxjs": "~7.8.2",
    "tslib": "^2.8.1"
  },
  "devDependencies": {
    "@angular/build": "^21.0.3",
    "@angular/cli": "~21.0.3",
    "@angular/compiler-cli": "^21.0.5",
    "@angular/material-luxon-adapter": "^21.0.3",
    "@sparbanken-syd/auth-backend": "^2.5.3",
    "@sparbanken-syd/borgo-helpers": "^21.0.0",
    "@sparbanken-syd/borgo-types": "^1.0.3",
    "@sparbanken-syd/personnummer": "^3.0.1",
    "@sparbanken-syd/sparbanken-syd-bankid": "^21.0.1",
    "@sparbanken-syd/sparbanken-syd-qr": "^21.0.0",
    "@sparbanken-syd/sparbanken-syd-theme": "^21.0.4",
    "@sparbanken-syd/sparbanken-syd-theme-m3": "^21.0.1-2222183215.0",
    "@standard-schema/spec": "^1.1.0",
    "@types/jasmine": "~5.1.13",
    "@types/luxon": "^3.7.1",
    "angular-eslint": "^21.1.0",
    "eslint": "^9.39.2",
    "jasmine-core": "~5.13.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0",
    "luxon": "^3.7.2",
    "postcss": "^8.5.6",
    "stylelint": "^16.26.1",
    "stylelint-config-standard-scss": "^16.0.0",
    "stylelint-scss": "^6.13.0",
    "typescript": "~5.9.3",
    "typescript-eslint": "^8.50.0"
  }
}
